// extracted by mini-css-extract-plugin
export default {"root":"BaseModal_root__GSNci","visible":"BaseModal_visible__aLK1W","modal":"BaseModal_modal__8vjLv","padding":"BaseModal_padding__FbWNe","overlay":"BaseModal_overlay__b2doJ"};